<script setup>
import { computed, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const items = computed(() => {
    return store.getters['stateHistory/items'];
});

// --- Methods ---

const open = (fullPath) => {
    // Navigates using the hash-based routing as per original logic
    window.location = '#' + fullPath;
};
</script>

<template>
    <div class="dashboard-panel-state-history card">
        <div class="card-header">
            Your viewing history
        </div>

        <div class="card-body small">
            <div
                v-for="(item, index) in items"
                :key="item.id"
                role="button"
                class="breadcrumb"
                :class="{ 'mb-1': index !== items.length - 1 }"
                @click="open(item.fullPath)"
            >
                <template v-if="item.fullPath">
                    <span class="breadcrumb-item">{{ item.componentTitle }}</span>
                    <span v-if="item.itemTitle" class="breadcrumb-item">
                        {{ item.itemTitle }}
                    </span>
                </template>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Scoped styles preserved empty */
</style>